import React, { CSSProperties } from 'react'
import IconCircle from './icon-circle'
import { IconType } from './design-constants'

type Props = {
   iconType: IconType
   headerText: string
   style?: CSSProperties
}

const IconHeader = (props: Props) => {
   return (
      <div className="flex items-center" style={props.style}>
         <IconCircle iconSize="small" iconType={props.iconType} />
         <span
            className="uppercase font-semibold text-[15px] text-[#e8489f] ml-[20px] data-[type=warning]:text-pink91 data-[type=insight]:text-blue91"
            data-type={props.iconType}
         >
            {props.headerText}
         </span>
      </div>
   )
}

export default IconHeader
